import React from 'react'
import styled from 'styled-components'

const Styles = styled.div`
  * {
    line-height: 20px;
    margin: 0;
  }
  h2 {
    margin-right: 1rem;
    margin-bottom: 0 !important;
  }
  .inner-wrapper {
    justify-content: center;
    align-items: center;
    margin: auto auto;
    // max-width: 800px;

    @media screen and (max-width: 460px) {
      display: block !important;
    }
  }
`

const BlogHeader = () => (
  <Styles className="section is-flex has-background-dark">
    <div className="container">
      <div className="columns is-desktop inner-wrapper is-flex">
        <div className="column">
          <h2 className="title has-text-white has-text-right has-text-left-mobile is-uppercase is-size-1">
            Blog
          </h2>
        </div>
        <div className="column is-three-quarters">
          <p className="has-text-white has-text-left is-size-5 has-text-weight-semibold">
            These are the words and paragraphs we use to communicate ideas that
            travel beyond your screen.
          </p>
        </div>
      </div>
    </div>
  </Styles>
)

export default BlogHeader



// WEBPACK FOOTER //
// ./src/components/blog/header.jsx